module.exports = __webpack_public_path__ + "img/octagon.9f7dc93d.svg";